var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriverCardTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75 6.676c0-.69.56-1.25 1.25-1.25h4c.69 0 1.25.56 1.25 1.25v.75h-6.5v-.75zm8 0v.75H19a.75.75 0 0 1 0 1.5H5a.75.75 0 0 1 0-1.5h2.25v-.75A2.75 2.75 0 0 1 10 3.926h4a2.75 2.75 0 0 1 2.75 2.75zM6 19.676v-9a1 1 0 0 1 1-1h10a1 1 0 0 1 1 1v9a3 3 0 0 1-3 3H9a3 3 0 0 1-3-3zm4-6.5a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5zm4 0a.5.5 0 0 1 .5.5v5a.5.5 0 0 1-1 0v-5a.5.5 0 0 1 .5-.5z",
    fill: "#EF2F2F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriverCardTrash);
export default __webpack_public_path__ + "static/media/driver-card-trash.d2d65c98c385b5787d45e2e3b74187d9.svg";
export { ForwardRef as ReactComponent };